import React, { useEffect } from "react";
import { ServerInterface } from "../ServerInterface";
import { loginDone } from "./Login";

export default function AutoRegister() {
  async function autoRegistieren() {
    let params = new URLSearchParams(document.location.search);
    let id = params.get("id");
    let pin = params.get("pin");

    var registerInfo = {
      memberId: id,
      pin: pin,
    };

    const data = await ServerInterface.register(registerInfo);
    if (data) {
      loginDone(data);
    }
  }

  useEffect(() => {
    autoRegistieren();
  }, []);

  return <div style={{}}>Hier sollte eine automatische Weiterleitung erfolgen</div>;
}
